export const formatDuration = (seconds) => {
  if (seconds == null || Number.isNaN(seconds)) return null;
  const total = Math.max(0, Math.floor(seconds));
  const hrs = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const parts = [];
  if (hrs) parts.push(`${hrs}h`);
  if (hrs || mins) parts.push(`${mins}m`);
  parts.push(`${secs}s`);
  return parts.join(' ');
};

export const computeElapsedLabel = (startTimestampMs, nowMs = Date.now()) => {
  if (startTimestampMs == null || Number.isNaN(startTimestampMs)) {
    return null;
  }
  if (nowMs == null || Number.isNaN(nowMs)) {
    return null;
  }
  const deltaMs = nowMs - startTimestampMs;
  if (!Number.isFinite(deltaMs)) {
    return null;
  }
  const deltaSeconds = Math.max(0, Math.floor(deltaMs / 1000));
  return formatDuration(deltaSeconds);
};

export const deriveActiveRunId = (runInfoRef, fallbackRunInfo) => {
  if (runInfoRef && runInfoRef.current && runInfoRef.current.run_id) {
    return runInfoRef.current.run_id;
  }
  if (fallbackRunInfo && fallbackRunInfo.run_id) {
    return fallbackRunInfo.run_id;
  }
  return null;
};

export const parseBackendTimestamp = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    const ts = value.getTime();
    return Number.isNaN(ts) ? null : ts;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const normalized = value.includes('T') ? value : value.replace(' ', 'T');
    const parsed = Date.parse(normalized);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (value && typeof value.toISOString === 'function') {
    const parsed = Date.parse(value.toISOString());
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
};

